export const loadLottiePlayer = () => import('@lottiefiles/dotlottie-svelte').then((module) => module.DotLottieSvelte);
